import { render, staticRenderFns } from "./SalidaTrasladoTableComponent.vue?vue&type=template&id=0d5b1ede&"
import script from "./SalidaTrasladoTableComponent.vue?vue&type=script&lang=js&"
export * from "./SalidaTrasladoTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports